export default "__VITE_ASSET__9badaec6__"